import styled from "styled-components";

export const AddToCartWrapper = styled.div`
  // TODO Fix AddToCart component in Atomic Ui
  & > div {
    align-items: center;
  }
`;
